import { DashboardSummary, DashboardSummaryContent, DashboardSummaryTitle } from '@/components/custom/dashboard';
import { Button } from '@/components/ui/button';
import { CardIcon } from '@/components/ui/card';
import { useCallback } from 'react';
import { FiFilter, FiMonitor, FiMousePointer, FiUsers } from 'react-icons/fi';
import { Link } from 'react-router-dom';

export function DashboardReportShortcut({ title, link, icon }) {
  const renderIcon = useCallback(icon => {
    switch (icon) {
      case 'monitor':
        return <FiMonitor size={20} />;
      case 'funil':
        return <FiFilter size={20} />;
      case 'users':
        return <FiUsers size={20} />;
      case 'pointer':
        return <FiMousePointer size={20} />;
    }
  }, []);

  return (
    <DashboardSummary variant="icon">
      <DashboardSummaryContent>
        <DashboardSummaryTitle>{title}</DashboardSummaryTitle>
        <Button
          variant="link"
          className="h-auto justify-start p-0 font-light"
          asChild
        >
          <Link to={link}>Acessar relatório</Link>
        </Button>
      </DashboardSummaryContent>

      <CardIcon className="self-start p-2">{renderIcon(icon)}</CardIcon>
    </DashboardSummary>
  );
}
